<template>
  <SimpleModuleDashboard
    :module-id="Modules.RECORDATORIOS"
    :profile-id="Profiles.PERSONAL"
    :actions="actions"
  />
</template>

<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'

export default {
  components: { SimpleModuleDashboard },
  data: () => ({
    Modules,
    Profiles,
    actions: [{ id: 'crudReminders', reference: 'crudReminders', route: 'RemindersStaffCrud', tone: 'primary' }],
  }),
}
</script>
